import React, { ReactNode } from 'react'
import styles from './Dropdown.module.sass'
import DropdownElement from '../DropdownElement/DropdownElement'
import Button from '../../../controls/Button/Button'
import CloseIcon from 'files/close.svg'
import Ellipsis from '../../../etc/Ellipsis/Ellipsis'
import FieldHints from '../FieldHints/FieldHints'
import { SelectProps } from '../../lists/Select/Select'
import { isDefinedArray } from '../../../../utils/utils'
import SUPIcon from 'files/sup.svg'
import FPIcon from 'files/fp.svg'

interface Props<T> extends SelectProps<T>{
    multi?: boolean,
    block?: boolean,
    content?: (selected: readonly T[], render: (item: T) => ReactNode) => ReactNode,
    onClear?: () => void,
    onChange?: (search: string, reset: boolean) => void,
    placeholder?: string,
    projectIcon?: boolean,
    projectIconSelected?: number | undefined,
    dropdownPlaceholder?: boolean
}

const defaultContent = <T extends unknown>(selected: readonly T[], render: (item: T) => ReactNode): ReactNode => selected.map(render).join()

const Dropdown = <T extends unknown>(props: Props<T>): JSX.Element => <FieldHints
    data={props.data}
    selected={props.selected}
    multi={props.multi}
    toKey={props.toKey}
    render={props.render}
    onClick={props.onClick}
    onChange={props.onChange}
>
    {
        ({isOpen, toggle}) => <DropdownElement
            className={props.className}
            block={props.block}
            active={isOpen}
            onToggle={toggle}
            placeholder={props.placeholder}
            selected={props.selected}
            dropdownPlaceholder={props.dropdownPlaceholder}
        >
            {
                props.selected.length && <>
                    {
                        props.multi && <div className={styles.count}>{props.selected.length}</div>
                    }
                    <Ellipsis projectIcon={true}>
                        {
                            !props.multi && props.projectIcon && props.selected && typeof props.projectIconSelected === 'number' ?
                                props.projectIconSelected === 0 ?
                                    <FPIcon className={styles.projectIcon} />:
                                    <SUPIcon className={styles.projectIcon} /> :
                                ''
                        }

                        {(props.content ?? defaultContent)(props.selected, props.render)}
                    </Ellipsis>
                    {
                        (props.onClear && isDefinedArray(props.selected)) && <Button
                            className={styles.clear}
                            onClick={event => {
                                event.stopPropagation()
                                props.onClear?.()
                            }}
                        >
                            <CloseIcon/>
                        </Button>
                    }
                </>
            }
        </DropdownElement>
    }
</FieldHints>

export default Dropdown